import React from 'react'

const AssetNameWithLabel = ({ name, label }) => (
  <>
    <span>{`${name}\n`}</span>
    <i style={{ fontSize: 'small' }}>{label}</i>
  </>
)
export default AssetNameWithLabel
